// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__5GcJa","footer":"ModalInfo_footer__1-RBn"};